document.addEventListener("DOMContentLoaded", function () {
  // Function to check if cart total is zero and prevent checkout
  function preventZeroCheckout() {
    // Get cart data
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        // Find all checkout buttons
        const checkoutButtons = document.querySelectorAll(
          '[name="checkout"], #checkout, #CartDrawer-Checkout'
        );

        // For each checkout button
        checkoutButtons.forEach((button) => {
          // Remove any existing event listeners by cloning and replacing
          const newButton = button.cloneNode(true);
          button.parentNode.replaceChild(newButton, button);

          // Add click event listener to validate cart total
          newButton.addEventListener("click", function (event) {
            // If cart total is 0, prevent checkout
            if (cart.total_price === 0) {
              event.preventDefault();
              event.stopPropagation();

              // Add error message
              const errorContainer =
                document.getElementById("cart-errors") ||
                document.getElementById("CartDrawer-CartErrors");

              if (errorContainer) {
                errorContainer.textContent =
                  "Cannot checkout with a $0 cart total.";
                errorContainer.style.display = "block";
                errorContainer.style.color = "red";
                errorContainer.style.marginTop = "10px";
              } else {
                alert("Cannot checkout with a $0 cart total.");
              }

              return false;
            }
          });
        });
      })
      .catch((error) => console.error("Error fetching cart:", error));
  }

  // Run initially
  preventZeroCheckout();

  // Run again when cart changes
  document.addEventListener("cart:updated", preventZeroCheckout);

  // Observe DOM changes to detect cart updates
  const cartObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (
        mutation.type === "childList" &&
        (mutation.target.classList.contains("cart__footer") ||
          mutation.target.classList.contains("drawer__inner"))
      ) {
        preventZeroCheckout();
      }
    });
  });

  // Start observing cart containers
  const cartFooter = document.querySelector(".cart__footer");
  const drawerInner = document.querySelector(".drawer__inner");

  if (cartFooter) {
    cartObserver.observe(cartFooter, { childList: true, subtree: true });
  }

  if (drawerInner) {
    cartObserver.observe(drawerInner, { childList: true, subtree: true });
  }
});
